import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { HeaderTitleComponent } from '../header-title/header-title.component';

@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrl: './main.component.scss',
  standalone:true,
  imports:[
    RouterModule,
    HeaderTitleComponent
  ]
})
export class MainComponent {}
